import script from "./Query.vue?vue&type=script&setup=true&lang=js"
export * from "./Query.vue?vue&type=script&setup=true&lang=js"

import "./Query.vue?vue&type=style&index=0&id=0547cac7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0547cac7"]])

export default __exports__